import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export const ParticlesBackground = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const options = useMemo(
    () => ({
      fullScreen: {
        enable: false,
        zIndex: 0
      },
      background: {
        color: {
          value: "transparent"
        }
      },
      fpsLimit: 60,
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: "grab"
          }
        },
        modes: {
          grab: {
            distance: 150,
            links: {
              opacity: 0.3
            }
          }
        }
      },
      particles: {
        color: {
          value: "#007AFF"
        },
        links: {
          color: "#007AFF",
          distance: 150,
          enable: true,
          opacity: 0.1,
          width: 1
        },
        move: {
          enable: true,
          random: true,
          speed: 0.5,
          straight: false
        },
        number: {
          density: {
            enable: true,
            area: 1200
          },
          value: 60
        },
        opacity: {
          value: 0.3
        },
        shape: {
          type: "circle"
        },
        size: {
          value: { min: 1, max: 2 }
        }
      },
      detectRetina: true
    }),
    []
  );

  if (!init) return null;

  return (
    <Particles
      id="tsparticles"
      options={options}
      className="absolute inset-0 z-0"
    />
  );
};
